let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lkNn0")).then(() => parcelRequire('17hUm'));